// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Example: MALE

export const SexSchema = t.keyof({
  MALE: null,
  FEMALE: null,
});

export type Sex = t.TypeOf<typeof SexSchema>;
